var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-question-view" }, [
    _c("div", { staticClass: "c-question-view_container c-view-container" }, [
      _c(
        "div",
        {
          staticClass:
            "c-question-view_container__inner c-view-container__inner",
        },
        [
          _c(
            "div",
            { staticClass: "c-question-view_content-col c-view-content-col" },
            [
              _c("h1", { staticClass: "c-question-view__heading" }, [
                _vm._v(_vm._s(_vm.categoryName)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "switches" }),
              _vm._v(" "),
              _c("div", { staticClass: "c-view-content-col__inner" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.question.Question) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "c-question-view__toggle-area" }, [
                  _c("p", { staticClass: "c-question-view__toggle-text" }, [
                    _vm._v("Yes"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "c-question-view__toggle",
                      class: {
                        "c-question-view__toggle--empty": _vm.isAnswerEmpty,
                      },
                    },
                    [
                      _c("SwitchToggle", {
                        attrs: {
                          showPotenitialSavings: _vm.showPotenitialSavings,
                          isAnswerEmpty: _vm.isAnswerEmpty,
                        },
                        model: {
                          value: _vm.answer,
                          callback: function ($$v) {
                            _vm.answer = $$v
                          },
                          expression: "answer",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "c-question-view__toggle-text" }, [
                    _vm._v("No"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "c-question-view__answer",
                    class: {
                      "c-question-view__answer--empty": _vm.isAnswerEmpty,
                    },
                  },
                  [
                    !_vm.showPotenitialSavings
                      ? _c("img", {
                          staticClass: "c-question-view__answer-image",
                          attrs: {
                            src: "_resources/app/client/assets/images/answer-blue.svg",
                            alt: "answer icon",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showPotenitialSavings
                      ? _c("img", {
                          staticClass: "c-question-view__answer-image",
                          attrs: {
                            src: "_resources/app/client/assets/images/answer-green.svg",
                            alt: "answer icon",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "c-question-view__answer-content-area" },
                      [
                        _vm.answer == "Yes"
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.question.AnswerYes),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.answer == "No"
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.question.AnswerNo),
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-question-view_animation-col c-view-animation-col",
            },
            [
              _c(
                "div",
                { staticClass: "c-question-view_animation-wrapper" },
                [
                  _c("div", {
                    staticClass: "c-question-view_animation-circle",
                  }),
                  _vm._v(" "),
                  _c("lottie-vue-player", {
                    attrs: {
                      src: _vm.animationsURL + _vm.question.AnimationURL,
                      "player-controls": false,
                      loop: true,
                      autoplay: true,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "c-view_savings-area c-view_savings-area--mobile",
                },
                [
                  _vm.showPotenitialSavings
                    ? _c(
                        "div",
                        { staticClass: "c-view_savings-area-potential" },
                        [
                          _vm._v(
                            "\n            Potential Savings:\n            "
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "c-view_savings-area-potential--bold",
                            },
                            [
                              _vm._v(
                                "+$" +
                                  _vm._s(
                                    _vm.getSavingsAmountWithMultiplier(
                                      _vm.question
                                    )
                                  )
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-view_savings-area-inner" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "c-view_savings-area-total" }, [
                      _c(
                        "h3",
                        { staticClass: "c-view_savings-area-total-text" },
                        [
                          _vm._v(
                            "\n                $" +
                              _vm._s(_vm.getAnnualSavingsTotal) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-view-controls__wrapper" }, [
      _c("div", { staticClass: "c-view-controls" }, [
        _c(
          "div",
          {
            staticClass:
              "c-view-controls__inner c-view-controls__inner--justify-content",
          },
          [
            _c("div", { staticClass: "c-buttons__wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "u-calc-button u-calc-button--prev",
                  on: { click: _vm.prev },
                },
                [_c("span"), _vm._v(" "), _c("p", [_vm._v("Previous")])]
              ),
              _vm._v(" "),
              _vm.canNavigateNext
                ? _c(
                    "button",
                    { staticClass: "u-calc-button", on: { click: _vm.next } },
                    [_c("p", [_vm._v("Next")]), _vm._v(" "), _c("span")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isAnswerEmpty
                ? _c(
                    "button",
                    {
                      staticClass: "u-calc-button u-calc-button--skip",
                      on: { click: _vm.next },
                    },
                    [_c("p", [_vm._v("Skip")]), _vm._v(" "), _c("span")]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-view_savings-area c-view_savings-area--desktop",
              },
              [
                _vm.showPotenitialSavings
                  ? _c(
                      "div",
                      { staticClass: "c-view_savings-area-potential" },
                      [
                        _vm._v(
                          "\n            Potential Savings:\n            "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "c-view_savings-area-potential--bold",
                          },
                          [
                            _vm._v(
                              "+$" +
                                _vm._s(
                                  _vm.getSavingsAmountWithMultiplier(
                                    _vm.question
                                  )
                                )
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "c-view_savings-area-inner" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-view_savings-area-total" }, [
                    _c(
                      "h3",
                      { staticClass: "c-view_savings-area-total-text" },
                      [
                        _vm._v(
                          "\n                $" +
                            _vm._s(_vm.getAnnualSavingsTotal) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-view_savings-area-headings" }, [
      _c("h5", { staticClass: "c-view_savings-area-top" }, [
        _c("span", [_vm._v("Total")]),
        _vm._v(" Estimated\n              "),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "c-view_savings-area-bottom" }, [
        _vm._v("Annual Savings:"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-view_savings-area-headings" }, [
      _c("h5", { staticClass: "c-view_savings-area-top" }, [
        _c("span", [_vm._v("Total")]),
        _vm._v(" Estimated\n              "),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "c-view_savings-area-bottom" }, [
        _vm._v("Annual Savings:"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }